const SEARCH_SERVICE_TYPE = {
  ENTITY: 'entity',
  ENTITY_RECORD: 'entity-record',
  NATIVE_LOOKUP: 'native-lookup',
};

export default SEARCH_SERVICE_TYPE;
